// Distance unit helpers — internal storage is always metres on SetPlan.distance_m.
// Display unit follows the user's `distance_unit` preference: "km" → m, "mi" → yd.

const YARDS_PER_METRE = 1.0936132983;
const METRES_PER_YARD = 0.9144;

export function distanceLabel(unitPref) {
  return unitPref === "mi" ? "yd" : "m";
}

export function metresToDisplay(metres, unitPref) {
  if (metres == null) return "";
  if (unitPref === "mi") return Math.round(metres * YARDS_PER_METRE);
  return Math.round(metres);
}

export function displayToMetres(value, unitPref) {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  if (unitPref === "mi") return num * METRES_PER_YARD;
  return num;
}
